<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card class="align-center d-flex flex-column pt-4">
      <CloseDialogButton :close="closeAuth" />
      <StorefrontImage class="display-none-height" size="large" />
      <Identification
        :fromLogin="fromLogin"
        :identification="identification"
        :to="to"
        :updateIdentification="updateIdentification"
        :updatePhone="updatePhone"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import Identification from "@/components/Auth/SignUp/Content/Identification.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "SignUpIdentificationDialog",
  components: {
    CloseDialogButton,
    Identification,
    StorefrontImage,
  },
  props: {
    closeAuth: Function,
    fromLogin: Boolean,
    identification: Object,
    outsideClick: Function,
    show: Boolean,
    to: Function,
    updateIdentification: Function,
    updatePhone: Function,
  },
};
</script>
<style scoped>
@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
